import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { SlingoConstants } from "../enum/SlingoConstants";
import { SymbolType } from "../enum/SymbolType";
/*
 * SymbolPayoutData.ts
 */
export class SymbolPayoutData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.type = SymbolType.getType(this.data.getString(SlingoConstants.PROPERTY_TYPE));
            this.multipliers = this.data.getNumberArray(SlingoConstants.PROPERTY_MULTIPLIERS);
        }
    }
    getType() {
        return this.type;
    }
    getMultipliers() {
        return this.multipliers?.slice();
    }
}
//# sourceMappingURL=SymbolPayoutData.js.map